import lessRequire from '../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import { DateRange } from 'react-date-range';
import isEqual from 'lodash/isEqual';

import theme from './calendar-theme-rewrite';
import Toggle from '../toggle';
import moment from 'moment';

lessRequire('modules/shared/calendar/calendar.less');

class Calendar extends React.Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		if (this.props.onInit) {
			this.props.onInit();
		}
	}

	shouldComponentUpdate(nextProps) {
		const isOpenStatusEqual = isEqual(this.props.isOpen, nextProps.isOpen);
		const isDateRangeEqual = isEqual(this.props.dateRange, nextProps.dateRange);

		if (isOpenStatusEqual && isDateRangeEqual) {
			return false;
		}

		return true;
	}

	render() {
		return (
			<div className="calendar-wrap">
				<Toggle
					head={
						<div className="calendar-wrap__head" onClick={ e => this.props.onToggle() }>
							<span className="selected-value">{ this.props.dateRange ? this.props.dateRange.join(' - ') : '' }</span>
						</div>
					}
					isShow={this.props.isOpen}
					onOutSideClick={e => this.props.onToggle()}>
					<div className="calendar-wrap__body">
						<DateRange
							ranges={this.props.ranges}
							startDate={this.props.startDate}
							endDate={this.props.endDate}
							onChange={ (date, selectedContextFunction) => {
								this.props.onChange(date);

								// Plugin doesn't have method for detect click source ( PredefinedRanges or Calendar )
								// I detect use defaultProps length
								const propsNameList = Object.keys(selectedContextFunction.defaultProps);
								if (propsNameList.length === 2) {
									this.props.onApply();
								}
							}}
							theme={theme}
							maxDate={moment()}
						/>
						<div className="calendar-wrap__body-btn">
							<button className="ui-btn ui-btn-primary apply" onClick={ e => this.props.onApply() }>
								{this.props.buttons.Apply}
							</button>
							<button className="ui-btn ui-btn-secondary close" onClick={ e => this.props.onToggle() }>
								{this.props.buttons.Close}
							</button>
						</div>
					</div>
				</Toggle>
			</div>
		);
	}
}

Calendar.propTypes = {
	onToggle: PropTypes.func,
	onChange: PropTypes.func,
	onApply: PropTypes.func,
	onInit: PropTypes.func,
	componentName: PropTypes.string,
	dateRange: PropTypes.array,
	isOpen: PropTypes.bool,
	ranges: PropTypes.object,
	startDate: PropTypes.object,
	endDate: PropTypes.object,
	buttons: PropTypes.object,
	lang: PropTypes.string,
	intl: PropTypes.func
};

export default Calendar;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/calendar/main.js